import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Tag, TagProps } from './tagsTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncTagPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<TagProps>>();
const tagPayloadCreator = getPayloadCreator<Tag>();
const tagsPayloadCreator = getPayloadCreator<Tag[]>();

export const getTags = createAction('GET_TAGS', getPayloadCreator());
export const getTagsSuccess = createAction('GET_TAGS_SUCCESS', syncTagPayloadCreator);
export const getTagsFailure = createAction('GET_TAGS_FAILURE', errorPayloadCreator);

export const createTag = createAction('CREATE_TAG', tagPayloadCreator);
export const createTagSuccess = createAction('CREATE_TAG_SUCCESS', tagPayloadCreator);
export const createTagFailure = createAction('CREATE_TAG_FAILURE', errorPayloadCreator);

export const updateTag = createAction('UPDATE_TAG', tagPayloadCreator);
export const updateTagSuccess = createAction('UPDATE_TAG_SUCCESS', tagPayloadCreator);
export const updateTagFailure = createAction('UPDATE_TAG_FAILURE', errorPayloadCreator);

export const deleteTag = createAction('DELETE_TAG', tagPayloadCreator);
export const deleteTagSuccess = createAction('DELETE_TAG_SUCCESS', tagPayloadCreator);
export const deleteTagFailure = createAction('DELETE_TAG_FAILURE', errorPayloadCreator);

export const batchTags = createAction('BATCH_TAGS', tagsPayloadCreator);
export const batchTagsSuccess = createAction('BATCH_TAGS_SUCCESS', tagsPayloadCreator);
export const batchTagsFailure = createAction('BATCH_TAGS_FAILURE', tagsPayloadCreator);
